// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "experiment".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { experimentStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "experiment" table (1:1 with a DB row, on the wire). */
export const experimentAtomSchema = z.object({
    id: z.string(),
    key: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    variants: z.unknown(),
    status: z.enum(experimentStatusValues),
    posthogFeatureKey: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=experiment.js.map